import { render, staticRenderFns } from "./ChatsMessage.vue?vue&type=template&id=bd2c9d32&scoped=true&"
import script from "./ChatsMessage.vue?vue&type=script&lang=js&"
export * from "./ChatsMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatsMessage.vue?vue&type=style&index=0&id=bd2c9d32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2c9d32",
  null
  
)

export default component.exports